/**
 * Shown in the detail panel when nothing is selected on the canvas.
 * Intentionally calm — empty states are not the place to be loud.
 */
export function EmptyPanel() {
  return (
    <div className="p-8 text-center text-ink-2">
      <div className="text-base font-bold mb-3 text-ink">Nothing selected</div>
      <p className="text-sm leading-relaxed">
        Click a scene on the canvas to edit it. Drag scenes to reposition. (Adding
        and removing scenes from the canvas itself lands in a later phase.)
      </p>
    </div>
  );
}
